module.exports = __webpack_public_path__ + "static/media/memento_multiverse.15270e93.gif";